import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [contactDropdownOpen, setContactDropdownOpen] = useState(false);
    const location = useLocation();
    const dropdownRef = useRef(null);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const toggleSubmenu = () => {
        setSubmenuOpen(prev => !prev);
    };

    const toggleContactDropdown = () => {
        setContactDropdownOpen(prev => !prev);
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setContactDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth > 1000) {
                setIsScrolled(window.scrollY > 50);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const isActive = (path) => (location.pathname === path ? 'active' : '');

    return (
        <Fragment>
            <header className={`header-area header-sticky ${menuOpen ? 'menu-open' : ''} ${isScrolled ? 'scrolled' : ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="main-nav">
                                <Link to="/" className={`logo ${isScrolled ? 'scrolled-logo' : ''}`}>
                                    <img src="assets/images/kumbhatech-logo.png" alt="Logo" />
                                </Link>
                                <ul className={`nav ${menuOpen ? 'open' : ''}`}>
                                    <li className="scroll-to-section">
                                        <Link to="/" className={isActive('/')}>Home</Link>
                                    </li>
                                    <li className="scroll-to-section">
                                        <Link to="/about-us" className={isActive('/about-us')}>About</Link>
                                    </li>
                                    <li>
                                        <Link to="/services" className={isActive('/services')}>Services</Link>
                                    </li>
                                    <li className={`has-sub ${submenuOpen ? 'open' : ''}`} onClick={toggleSubmenu}>
                                        <Link to="#" className={isActive('/kumbhaatech-affordabe-software-development-chennai')}>Discover Us</Link>
                                        <ul className="sub-menu">
                                            <li>
                                                <Link to="/kumbhaatech-affordabe-software-development-chennai" className={isActive('/kumbhaatech-affordabe-software-development-chennai')}>Projects</Link>
                                            </li>

                                            <li><Link to="/career" className={isActive('/career')}>Career</Link></li>
                                            <li><Link to="/how-we-works" className={isActive('/how-we-works')}>How We Work</Link></li>
                                        </ul>
                                    </li>
                                    <li className="scroll-to-section">
                                        <Link to="/kumbhatech-affordable-website-design-chennai" className={isActive('/kumbhatech-affordable-website-design-chennai')}>Contact Us</Link>
                                    </li>
                                </ul>

                                {/* Get in Touch Dropdown */}
                                <div className="header-contact t-dis-none" ref={dropdownRef}>
                                    <div className="get-in-touch-wrapper">
                                        <span onClick={toggleContactDropdown} className="get-in-touch-trigger">
                                            <span className=''>Get in Touch</span>

                                        </span>

                                        {contactDropdownOpen && (
                                            <div className="contact-dropdown">
                                                <p>Wish to know more about our Services? Give us a call to schedule.</p>
                                                <a href="tel:7880002227">7880002227</a>
                                            </div>
                                        )}
                                    </div>
                                </div>


                                <span className="menu-trigger" onClick={toggleMenu}>
                                    <span>Menu</span>
                                </span>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};

export default Header;
